import {
  collection,
  doc,
  getDocs,
  limit,
  orderBy,
  query,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "@/lib/firebase";
import { COLLECTIONS } from "@/constants/firestoreCollections";

export interface SuggestionReview {
  id: string;
  userId: string;
  userEmail?: string;
  userName?: string;
  rating: number;
  description: string;
  agencyId?: string;
  agencyName?: string;
  status: string;
  createdAt: { seconds: number; nanoseconds?: number } | Date;
  updatedAt?: { seconds: number; nanoseconds?: number } | Date;
}

function parseReview(doc: { id: string; data: () => Record<string, unknown> }): SuggestionReview {
  const d = doc.data();
  return {
    id: doc.id,
    userId: (d.userId as string) ?? "",
    userEmail: d.userEmail as string | undefined,
    userName: d.userName as string | undefined,
    rating: (d.rating as number) ?? 0,
    description: (d.description as string) ?? "",
    agencyId: d.agencyId as string | undefined,
    agencyName: d.agencyName as string | undefined,
    status: (d.status as string) ?? "pendiente",
    createdAt: (d.createdAt as { seconds: number }) ?? { seconds: 0 },
    updatedAt: d.updatedAt as { seconds: number } | undefined,
  };
}

/** Obtiene las últimas sugerencias (reviews del buzón) para mostrar en el sidebar */
export async function getRecentSuggestions(count: number = 8): Promise<SuggestionReview[]> {
  const q = query(
    collection(db, COLLECTIONS.REVIEWS),
    orderBy("createdAt", "desc"),
    limit(count)
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((doc) => parseReview({ id: doc.id, data: () => doc.data() }));
}

/** Obtiene todas las sugerencias (para la página completa) */
export async function getAllSuggestions(): Promise<SuggestionReview[]> {
  const q = query(
    collection(db, COLLECTIONS.REVIEWS),
    orderBy("createdAt", "desc")
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((doc) => parseReview({ id: doc.id, data: () => doc.data() }));
}

export async function updateSuggestionStatus(id: string, status: string) {
  const ref = doc(db, COLLECTIONS.REVIEWS, id);
  await updateDoc(ref, {
    status,
    updatedAt: serverTimestamp(),
  });
}

export async function addSuggestionResponse(id: string, responseText: string) {
  const ref = doc(db, COLLECTIONS.REVIEWS, id);
  await updateDoc(ref, {
    response: responseText,
    respondedAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}
